import Link from 'next/link'
import AppImage from '@/components/AppImage'

export default function TeamArchiveItems({ items }) {
  if (!items || items.length === 0) {
    return null
  }

  const gridClass = `
    @[960px]/team-grid:grid-cols-4
    @[960px]/team-grid:gap-l
    @[720px]/team-grid:grid-cols-3
    @[720px]/team-grid:gap-m
    @[340px]/team-grid:grid-cols-2 
    grid-cols-1
    gap-x-s
    gap-y-m
  `

  return (
    <div className={`grid ${gridClass}`}>
      {items.map((item, index) => {
        const {
          link,
          title,
          job_title: jobTitle,
          profile_image: profileImage,
          email,
          telephone,
          social_media: { facebook, twitter, linkedin } = {},
        } = item

        const { url: imageUrl, alt: imageAlt } = profileImage || {}

        return (
          <div key={index} className="flex flex-col gap-s [&:has(img:hover)_a]:text-link">
            <div>
              {imageUrl ? (
                <Link
                  href={link}
                  className="max-w-[ inline-block aspect-square max-w-[min(120px,66%)] overflow-hidden rounded-full">
                  <AppImage
                    path={imageUrl}
                    alt={imageAlt || ''}
                    className=""
                    width={120}
                    height={120}
                    transforms={{
                      height: '120',
                      width: '120',
                    }}
                    sizes="min(120px, calc(100vw - 40px))"
                    srcSet={{
                      120: { width: '120', height: '120' },
                      240: { width: '240', height: '240' },
                      360: { width: '360', height: '360' },
                      480: { width: '480', height: '480' },
                    }}
                  />
                </Link>
              ) : null}
            </div>

            <div className="flex flex-col gap-xxs">
              <Link href={link} className="h5 mb-0 block hover:text-link">
                {title}
              </Link>

              <span className="block text-[length:--p-s-size] text-fg-body">{jobTitle}</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}
